import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuthorization } from '@hooks/useAuthorization';
import { useStorageFeatureFlag } from '@hooks/useStorageFeatureFlag';
import { useUser } from '@hooks/useUser';
import { FeatureFlag } from '@constants/featureFlags';
import { USER_MENU_SETTINGS } from '@constants/user-menu';
import styles from './TopNavigation.module.scss';

const TopNavigation = () => {
  const { user } = useUser();
  const { hasPermission } = useAuthorization();
  const isRbacEnabled = useStorageFeatureFlag(FeatureFlag.RBAC);

  const visibleMenuItems = USER_MENU_SETTINGS.filter((item) => {
    if (item.key === 'logout') return false;

    const hasLegacyRoleAccess = !item.userAccess || item.userAccess.includes(user.role);

    // TODO(RBAC): The hasLegacyRoleAccess check is a temporary measure until organization-level
    // permissions are fully implemented in the RBAC system. Once complete, this check
    // can be removed, and authorization will be handled solely by `hasPermission`.
    if (!isRbacEnabled) return hasLegacyRoleAccess;

    const hasRbacPermission = hasPermission(item.permissions || {});
    return hasRbacPermission && hasLegacyRoleAccess;
  });

  return (
    <div className={styles.wrapper}>
      <div className={styles.topNavigation_container}>
        {visibleMenuItems.map((item) => (
          <NavLink
            className={({ isActive }) => `${styles.link} ${isActive && styles.link_active}`}
            to={item.link || ''}
            key={item.key}
          >
            {item.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default TopNavigation;
